import CustomCard from '../../../../../components/CustomCard';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import CustomTab from '../../../../../components/CustomTab';
import React, {useState} from 'react';
import {TABS_WHITE_LIST_MODEL} from '../Model/Models';
import {useTranslation} from "react-i18next";
import WhiteListAutomatic from "./WhiteListAutomatic";
import WhiteListManual from "./WhiteListManual";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const WhiteListTabs = ({
    emptyFields,
    setEmptyFields,
    photoPickerFile,
    setPhotoPickerFile,
    eventDetail,
    setEventDetail
}) => {
    const {t} = useTranslation();
    const [selectedTab, setSelectedTab] = useState(TABS_WHITE_LIST_MODEL.AUTOMATIC.key);

    return (
        <>
            <CustomCard classes={"w-100"} classCard={'card-border-8px'}>
                <div className='row'>
                    <div className='col-12 px-0'>
                        <CustomTabContainer
                            activeTab={selectedTab}
                            setActiveTab={(e) => {
                                setSelectedTab(e);
                            }}
                            className="border-0 px-3"
                            paddingClass=''
                        >
                            {Object.values(TABS_WHITE_LIST_MODEL).map((item) => (
                                <CustomTab
                                    key={item.key}
                                    id={item.key}
                                    title={t(item.translation)}
                                    icon={item?.icon}
                                    selected={selectedTab === item.key}
                                    onClick={() => {
                                        setSelectedTab(item.key)
                                    }}
                                />
                            ))}
                        </CustomTabContainer>
                    </div>

                    { selectedTab === TABS_WHITE_LIST_MODEL.AUTOMATIC.key ?
                        <WhiteListAutomatic
                            emptyFields={emptyFields}
                            setEmptyFields={setEmptyFields}
                            photoPickerFile={photoPickerFile}
                            setPhotoPickerFile={setPhotoPickerFile}
                        />
                        :
                        <WhiteListManual
                            eventDetail={eventDetail}
                            setEventDetail={setEventDetail}
                            setEmptyFields={setEmptyFields}
                        />
                    }
                </div>

            </CustomCard>
        </>
    );

}

export default WhiteListTabs
